import {type PartialOptions, UI} from "../../../../../../stem-core/ui/UIBase";
import {Modal, ModalStyle} from "../../../../../ui/Modal.jsx";
import {Messages} from "../../../../../Messages.js";
import {wrapInSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {DefaultCodeConfirmationForm} from "../../../../../common/auth/DefaultCodeConfirmationForm.jsx";
import {NOOP_FUNCTION} from "../../../../../../stem-core/base/Utils.js";
import {apiConfirmCloseAccount} from "../../../../../../client/state/UserProfileStore.js";
import {MessageElement} from "../../../../../widget/ui/MessageElement.jsx";
import {registerStyle} from "../../../../../../stem-core/ui/style/Theme";
import {styleRule} from "../../../../../../stem-core/decorators/Style";
import type {UserProfile} from "../../../../../../client/state/UserProfileStore";


export class CloseAccountConfirmationModalStyle extends ModalStyle {
    @styleRule
    cancel = {
        cursor: "pointer",
        padding: 6,
        width: "fit-content",
        color: this.themeProps.MERCHANT_2,
        margin: "6px auto 0",
    };
}

interface CloseAccountConfirmationModalOptions {
    onConfirmSuccess?: (...args: any[]) => void;
    userProfile?: UserProfile;
}

@registerStyle(CloseAccountConfirmationModalStyle)
export class CloseAccountConfirmationModal extends Modal<CloseAccountConfirmationModalOptions> {
    getDefaultOptions(): PartialOptions<CloseAccountConfirmationModal> {
        return {
            ...super.getDefaultOptions(),
            title: Messages.closeAccountModalTitle,
            userProfile: null,
            closeTestId: "closeAccountConfirmationModal",
            hideOnScrimClick: false,
            onConfirmSuccess: NOOP_FUNCTION,
        };
    }

    render() {
        const {styleSheet} = this;
        const {userProfile} = this.options;

        return [
            <MessageElement message={Messages.closeAccountConfirmationLine1(userProfile.getEmail())}/>,
            <DefaultCodeConfirmationForm onSubmit={(code, callback, errorCallback) =>
                this.handleCloseConfirmationCodeSubmit(code, callback, errorCallback)}
            />,
            <div className={styleSheet.cancel} onClick={() => this.hide()}>{Messages.cancel}</div>
        ]
    }

    @wrapInSpinner
    async handleCloseConfirmationCodeSubmit(code: string, successCallback = NOOP_FUNCTION, errorCallback = NOOP_FUNCTION) {
        const {onConfirmSuccess} = this.options;

        try {
            const response = await apiConfirmCloseAccount({code});
            successCallback(response);
            onConfirmSuccess();
            this.hide();
        } catch (error) {
            errorCallback(error);
            throw error;
        }
    }
}
